import PropTypes from "prop-types";
import { Flex, IconButton } from "@radix-ui/themes";
import AlertComponent from "./AlertComponent";
import useResizeEffect from "../../../../hooks/useResizeEffect";
import FontAwesome from "../../../utilities/FontAwesome";
import { useT } from "../../../utilities/TranslatedText";
import styles from "./styles/BannerComponent.module.scss";

const BannerComponent = (props) => {
  const { alerts } = props;
  const t = useT();

  function dismiss() {
    props.handleDismiss(Object.assign({}, props, { type: "banner" }));
  }

  useResizeEffect(
    { current: document.querySelector(".navigation-container") },
    () => {
      const navContainer = document.querySelector(
        ".navigation-container",
      ) as HTMLDivElement;
      (
        document.querySelector(".notification-container") as HTMLDivElement
      ).style.top = navContainer.clientHeight + "px";
    },
  );

  return (
    <Flex
      role="alert"
      align="center"
      gap="3"
      className={`sb-alert-banner sb-content-width ${styles.banner}`}
    >
      <div className={styles.message}>
        {alerts.map((alert) => (
          <AlertComponent key={alert.id} message={alert.message} />
        ))}
      </div>
      <IconButton
        variant="ghost"
        radius="full"
        onClick={dismiss}
        aria-label={t("Close")}
      >
        <FontAwesome prefix={"fas"} name={"fa-times"} />
      </IconButton>
    </Flex>
  );
};

BannerComponent.propTypes = {
  alerts: PropTypes.array.isRequired,
  handleDismiss: PropTypes.func,
};

export default BannerComponent;
